// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1plCQ","item":"PaymentsMobile_item__2wNA-","label":"PaymentsMobile_label__1DekX","amount":"PaymentsMobile_amount__280Vl"};